import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { MyMediaUploadProvider } from "./context/MyMediaUploadContext.jsx";
import { CanvaProvider } from "./context/CanvaContext.jsx";
import { DraftPromptProvider } from "./context/DraftPromptContext.jsx";

import PrivateRoute from "./components/PrivateRoute";
import Captions from "./pages/Captions";
import Reels from "./pages/Reels";
import Videos from "./pages/Videos";
import TemplatesStories from "./pages/TemplatesStories";
import TemplatesCarousels from "./pages/TemplatesCarousels";
import TemplatesContentVault from "./pages/TemplatesContentVault";
import Images from "./pages/Images";
import SocialMedia from "./pages/SocialMedia";
import ForYou from "./pages/ForYou";
import MyCalendar from "./pages/MyCalendar";
import MyFavorites from "./pages/MyFavorites";
import MyCanva from "./pages/MyCanva";
import MyDrafts from "./pages/MyDrafts";
import MyMedia from "./pages/MyMedia.jsx";
import Courses from "./pages/Courses.jsx";
import Course from "./pages/Course.jsx";
import Blueprints from "./pages/Blueprints.jsx";
import Events from "./pages/Events.jsx";
import TemplatesEmailsLeadMagnet from "./pages/TemplatesEmailsLeadMagnet.jsx";
import TemplatesEmailsSaleCampaign from "./pages/TemplatesEmailsSaleCampaign.jsx";
import TemplatesEmailsSocialTemplate from "./pages/TemplatesEmailsSocialTemplate.jsx";
import Emails from "./pages/Emails.jsx";
import Preferences from "./pages/Preferences.jsx";
import Welcome from "./pages/Welcome.jsx";
import Onboarding from "./pages/Onboarding.jsx";
import Account from "./pages/Account.jsx";
import Plans from "./pages/Plans.jsx";
import AllBonuses from "./pages/AllBonuses.jsx";

function App() {
  return (
    <AuthProvider>
      <DraftPromptProvider>
        <MyMediaUploadProvider>
          <CanvaProvider>
            <Router>
              <Routes>
                
                <Route
                  path="/"
                  element={
                    <PrivateRoute>
                      <Account />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/captions"
                  element={
                    <PrivateRoute>
                      <Captions />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/reels"
                  element={
                    <PrivateRoute>
                      <Reels />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/videos"
                  element={
                    <PrivateRoute>
                      <Videos />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/stories"
                  element={
                    <PrivateRoute>
                      <TemplatesStories />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/carousels"
                  element={
                    <PrivateRoute>
                      <TemplatesCarousels />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/content-vault"
                  element={
                    <PrivateRoute>
                      <TemplatesContentVault />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/images"
                  element={
                    <PrivateRoute>
                      <Images />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/social-media"
                  element={
                    <PrivateRoute>
                      <SocialMedia />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/for-you"
                  element={
                    <PrivateRoute>
                      <ForYou />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/my-calendar"
                  element={
                    <PrivateRoute>
                      <MyCalendar />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/my-favorites"
                  element={
                    <PrivateRoute>
                      <MyFavorites />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/my-drafts"
                  element={
                    <PrivateRoute>
                      <MyDrafts />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/my-canva"
                  element={
                    <PrivateRoute>
                      <MyCanva />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/my-media"
                  element={
                    <PrivateRoute>
                      <MyMedia />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/courses"
                  element={
                    <PrivateRoute>
                      <Courses />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/course"
                  element={
                    <PrivateRoute>
                      <Course />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/blueprints"
                  element={
                    <PrivateRoute>
                      <Blueprints />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/events"
                  element={
                    <PrivateRoute>
                      <Events />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/emails"
                  element={
                    <PrivateRoute>
                      <Emails />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/emails-drafts"
                  element={
                    <PrivateRoute>
                      <Emails />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/emails-lead-magnet"
                  element={
                    <PrivateRoute>
                      <TemplatesEmailsLeadMagnet />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/emails-sale-campaign"
                  element={
                    <PrivateRoute>
                      <TemplatesEmailsSaleCampaign />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/emails-social-template"
                  element={
                    <PrivateRoute>
                      <TemplatesEmailsSocialTemplate />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/preferences"
                  element={
                    <PrivateRoute>
                      <Preferences />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/welcome"
                  element={
                    <PrivateRoute>
                      <Welcome />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/onboarding"
                  element={
                    <PrivateRoute>
                      <Onboarding />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/account"
                  element={
                    <PrivateRoute>
                      <Account />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/plans"
                  element={
                    <PrivateRoute>
                      <Plans />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/all-bonuses"
                  element={
                    <PrivateRoute>
                      <AllBonuses />
                    </PrivateRoute>
                  }
                />

              </Routes>

            </Router>
          </CanvaProvider>
        </MyMediaUploadProvider>
      </DraftPromptProvider>
    </AuthProvider>
  );
}

export default App;
